import React, { useEffect, useState } from "react";
import RadioButtonCard from "components/radioButtonCard/RadioButtonCard";
import Spacer from "components/Spacer/Spacer";
import Card from "components/visitCommon/Card";
import StepScreenContainer from "components/visitCommon/StepScreenContainer";
import Button from "components/buttons/Button";
import useModal from "hooks/useModal";
import AddChildModal from "../../common/AddChildModal";
import { useBehaviorHealthVisitFlow } from "hooks/useVisitFlow";
import { useDispatch } from "react-redux";
import useVisitStepChange from "hooks/useVisitStepChange";
import { useHistory } from "react-router-dom";
import useCreateBehaviorHealthVisit from "hooks/visit/useCreateBehaviorHealthVisit";
import useUpdateBehaviorHealthVisit from "hooks/visit/useUpdateBehaviorHealthVisit";
import { behaviorHealthVisitFlowReducers } from "reducers/behavior_health/behaviorHealthVisitFlowReducer";
import { bh_sub_steps } from "helpers/enum";
import MedicalAssistant from "components/MedicalAssistant/MedicalAssistant";

function SelectChildForBehaviorHealth() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { rightButtonClickRef } = useVisitStepChange();
  rightButtonClickRef.current = onRightButtonClick;
  const { setShowModal } = useModal();
  const [selected, setSelected] = useState(null);
  const {
    patientsList,
    incompleteData,
    subSteps,
  } = useBehaviorHealthVisitFlow();
  const currentScreenValueFromStore = subSteps[bh_sub_steps.select_child].value;

  const { createNewVisit, creatingVisit } = useCreateBehaviorHealthVisit();
  const { updateVisit, updatingVisit } = useUpdateBehaviorHealthVisit();

  useEffect(() => {
    if (currentScreenValueFromStore) {
      setSelected(currentScreenValueFromStore);
    }
  }, [currentScreenValueFromStore, patientsList]);

  useEffect(() => {
    if (selected?.length) {
      dispatch(
        behaviorHealthVisitFlowReducers.select_child({
          isValid: true,
        })
      );
    } else {
      dispatch(
        behaviorHealthVisitFlowReducers.select_child({
          isValid: false,
        })
      );
    }
  }, [dispatch, selected]);

  function onRightButtonClick() {
    if (incompleteData && Object.keys(incompleteData)?.length) {
      updateVisit({
        payload: {
          case: {
            id: incompleteData?.id,
            patient_id: patientsList?.find((el) => el?.full_name === selected)
              ?.id,
            behavior_health_steps: incompleteData?.behavior_health_steps,
          },
        },
        change_current_screen: false,
        screen_to_complete: null,
        callBack: () => {
          dispatch(
            behaviorHealthVisitFlowReducers.select_child({
              value: selected,
            })
          );
          history.push("/visit/behavior-health/pricing");
        },
      });
    } else {
      createNewVisit({
        patient_id: patientsList?.find((el) => el?.full_name === selected)?.id,
        change_current_screen: false,
        screen_to_complete: null,
        callBack: () => {
          dispatch(
            behaviorHealthVisitFlowReducers.select_child({
              value: selected,
            })
          );
          history.push("/visit/behavior-health/pricing");
        },
      });
    }
  }

  return (
    <StepScreenContainer>
      <MedicalAssistant content={<p>Please, select child.</p>} />
      <Spacer height={40} />
      <Card>
        <RadioButtonCard
          loading={creatingVisit}
          options={patientsList
            ?.filter(
              (patient) =>
                patient?.relationship_with_account &&
                patient.relationship_with_account === "pappa"
            )
            ?.map((el) => el?.full_name)}
          onSelect={setSelected}
          selected={selected}
        />
        <Spacer height="38" />
        <Button
          disabled={updatingVisit}
          onClick={() => {
            setShowModal({
              state: true,
              children: (_, onClose) => (
                <AddChildModal
                  onClose={(e) => {
                    if (e !== null) {
                      setSelected(e);
                    }
                    onClose();
                  }}
                />
              ),
              data: null,
            });
          }}
          label="Add Child"
          outlined
        />
      </Card>
    </StepScreenContainer>
  );
}

export default SelectChildForBehaviorHealth;
